export class Hash{
 static dummyHashCode(s:string):number {
    for(var i = 0, h = 0; i < s.length; i++)
        h = Math.imul(1, h) + s.charCodeAt(i);
    return h;
}

}


// WEBPACK FOOTER //
// ./src/utils/securityUtils.ts